





























































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator'
import { ReportType } from '@/domain/ReportType'
import FileData from '@/domain/FileData'

@Component
export default class ReportTypeDialogComponent extends Vue {

  @PropSync("value", { type: Boolean , default: false, required: false })
  dialog!: boolean

  @PropSync("default", { type: ReportType, default: () => new ReportType(), required: true })
  dto!: ReportType

  @Prop({ default: true })
  isNew!: boolean

  /** バリデーション */
  invalid = false

  /**
   * 初期化
   */
  reset() {
    this.dto = new ReportType()
  }

  /**
   * 報告書テンプレートの登録
   */
  onChangeReportTemplate(file: File | undefined) {
    if (file === undefined) {
      this.dto.reportTemplate = new FileData()
    } else {
      this.readFileAsync(file).then(res => {
        if (res !== undefined) {
          this.dto.reportTemplate = res
        }
      })
    }
  }

  /**
   * ファイルの読み込み(base64形式)
   */
/*  async readFileAsync(file: File): Promise<FileData> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => {
        if (typeof reader.result === "string") {
          resolve({filename: file.name, content: reader.result})
        } else {
          resolve(undefined)
        }
      }
      reader.onerror = (error) => {
        reject(error)
      }
      reader.readAsDataURL(file)
    })
  }
*/
  async readFileAsync(file: File): Promise<FileData> {
    return new Promise<FileData>((resolve, reject) => {
      const reader = new FileReader()

      reader.onload = () => {
        if (typeof reader.result === "string") {
          resolve({filename: file.name, content: reader.result})
        } else {
          reject(new Error("FileReader result is not string"))
        }
      }

      reader.onerror = () => {
        reject(reader.error)
      }

      reader.readAsDataURL(file)
    })
  }

  /**
   * キャンセルボタンのクリック
   */  
  onCancel() {
    this.dialog = false
    this.reset()
  }

  /**
   * 確定のクリック
   */  
  onSubmit() {
    this.dialog = false
    this.$emit("input", this.dto)
    this.reset()
  }

}
